module.exports = __webpack_public_path__ + "static/media/client-logo.aa8255dd.svg";